import { baseApi, Tag } from './base'

export type ModaliteComplementaire = {
    code_situation_parcours_de_soin?: string
    nom_medecin_parcours_de_soins?: string
    prenom_medecin_parcours_de_soins?: string
    code_majoration_ou_modificateurs?: string
    code_justif_exoneration_acte?: string
    code_qualificatif_depence?: string
    code_association?: string
    is_remboursement_exceptionnel?: boolean
    is_ald?: boolean
    taux_abattement?: string
}

export type CreateDesmosActDto = {
    numero_finess_centre?: string
    libelle: string
    date_realisation: string
    honoraire?: string
    supplement?: string
    id_transposition: string
    ref_acte_juxta?: string
    nom_praticien?: string
    prenom_praticien?: string
    rpps_praticien?: string
    modalite_complementaire?: ModaliteComplementaire
}

export type CreateDesmosActResponse = {
    success: boolean
    desmosPatientId: string
    actId: string
    message: string
}

export type GetDesmosPatientResponse = {
    desmosPatientId: string
    medconnectPatientId: string
}

export const desmosApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        createDesmosAct: builder.mutation<CreateDesmosActResponse, { patientId: string; actData: CreateDesmosActDto }>({
            query: ({ patientId, actData }) => ({
                url: `/desmos/patients/${patientId}/acts`,
                method: 'POST',
                body: actData,
            }),
            invalidatesTags: (_result, _error, args) => [{ type: Tag.PATIENT, id: args.patientId }],
        }),
        getDesmosPatient: builder.query<GetDesmosPatientResponse, string>({
            query: (patientId) => `/desmos/patients/${patientId}`,
            providesTags: (_result, _error, patientId) => [{ type: Tag.PATIENT, id: patientId }],
        }),
    }),
    overrideExisting: false,
})

